import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import {  OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { SeoService } from '../../common/seo.service';
import { Constants } from '../../common/constants';
interface RouteData {
  title: string;
  ogUrl: string;
  description?: string;
}
@Component({
  selector: 'app-corporate-giving',
  templateUrl: './corporate-giving.component.html',
  styleUrls: ['./corporate-giving.component.css']
})

export class CorporateGivingComponent {
  isBrowser: boolean;
  baseUrl=Constants.baseUrl;

  
  constructor(
    private title: Title,
    private meta: Meta,private router: Router,
    private activatedRoute: ActivatedRoute,private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
  
    private seoService:SeoService, @Inject(PLATFORM_ID) private platformId: any,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }
  swiperBreakpoints = {
    320: { slidesPerView: 1 },      
    768: { slidesPerView: 2 },      
    1024: { slidesPerView: 3 }      
  };
  ngOnInit() {
   
  
    let script = this._renderer2.createElement('script');
  script.type = `application/ld+json`;
  script.text = `
  {
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/corporate-giving/"
  },
  "headline": "Corporate Giving | Making a Difference at Maganti IT",
  "description": "We pride ourselves on giving back to the community and supporting local businesses and organizations.",
  "image": "https://mitresource.com/assets/images/carporategiving_images/webeliveimage.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-04-12"
}
`;
 
  this._renderer2.appendChild(this._document.body, script);
  this.seoService.createLinkForCanonicalURL();
  this.setTitleAndMetaTags(); 
  }


  private setTitleAndMetaTags(): void {
    this.title.setTitle('Corporate Giving | Making a Difference at Maganti IT');

    this.meta.addTags([
      { name: 'description', content: 'We pride ourselves on giving back to the community and supporting local businesses and organizations.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Corporate Giving | Making a Difference at Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/corporate-giving/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/carporategiving_images/webeliveimage.png' },
      { property: 'og:description', content: 'We pride ourselves on giving back to the community and supporting local businesses and organizations.' },
    ]);
  }
}
